import { render, staticRenderFns } from "./NurseryMonitoring.vue?vue&type=template&id=af625cf6&scoped=true"
import script from "./NurseryMonitoring.vue?vue&type=script&lang=js"
export * from "./NurseryMonitoring.vue?vue&type=script&lang=js"
import style0 from "./NurseryMonitoring.vue?vue&type=style&index=0&id=af625cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af625cf6",
  null
  
)

export default component.exports